export class ParseAddress {

    public static dealReturnAddress(data) {
        let params = {
            country: '', province: '', city: '', district: '', street: '', buildID: '', buildingName: '', buildNo: ''
        }
        let detail_address = !!data[1] && data[1].address_components.length >= 1 && !!data[1].address_components
            ? data[0].address_components.concat(data[1].address_components) : data[0].address_components//最详细的地址
        // 先查找数组0，再查找数组1对0进行地址补充
        if (detail_address.length < 1) {
            return params;
        }
        for (let i = 0, len = detail_address.length; i < len; i++) {
            let each = this.getGoogleKey(detail_address[i], params);
            params = Object.assign(params, each);
        }
        // 对待香港澳门和台湾进行特殊地址处理
        params = this.specialDeal(params);
        return params;
    }

    private static getGoogleKey(data, params) {
        let key = {}
        if (data.types.indexOf('country') > -1) {
            key = { country: data.long_name }
        } else if (data.types.indexOf('administrative_area_level_1') > -1) {
            key = !!params.province ? { province: params.province } : { province: data.long_name }
        } else if (data.types.indexOf('administrative_area_level_2') > -1 || data.types.indexOf('locality') > -1) {
            key = !!params.city ? { city: params.city } : { city: data.long_name }
        } else if (data.types.indexOf('administrative_area_level_3') > -1 || data.types.indexOf('sublocality_level_1') > -1) {
            key = !!params.district ? { district: params.district } : { district: data.long_name }
        } else if (data.types.indexOf('street_address') > -1 || data.types.indexOf('route') > -1) {
            key = !!params.street ? { street: params.street } : { street: data.long_name }
        } else if (data.types.indexOf('premise') > -1) {
            key = !!params.buildingName ? { buildingName: params.buildingName } : { buildingName: data.long_name }
        }
        return key
    }

    private static specialDeal(params) {
        let province = params.country, city = params.province
        let country_en = 'China', contry_zh = '中国', change = false
        switch (params.country) {
            case 'Hong Kong':
                change = true
                params.country = country_en
                break
            case '香港':
                change = true
                params.country = contry_zh
                break
            case 'Taiwan':
                change = true
                params.country = country_en
                break
            case '台湾':
                change = true
                params.country = contry_zh
                break
            case 'Macao':
                change = true
                params.country = country_en
                break
            case '澳门':
                change = true
                params.country = contry_zh
                break
        }
        if (change) {
            params.province = province
            params.city = city
        }
        return params
    }
}